import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import styles from "./MessageItem.module.css";
import { faReply } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import ReplyPreview from "components/ReplyPreview";
import { formatMessageDate } from "utils/helpers";
export default function MessageItem({ message, onReplyClick, onCancelReplyTo }) {
  //style select for my or not my message

  var messageStyle = "";

  if (message.myMessage) {
    messageStyle = "myMessage";
  }

  const replyRef = useRef(null);
  const bubbleRef = useRef(null);
  const bracketRef = useRef(null);

  useEffect(() => {

    if (message.currentContactId === message.fromContactId) {
      messageStyle = "myMessage"
    }

    if (!message.repliedToMessage) return;

    const replyBox = replyRef.current?.getBoundingClientRect();
    const messageBox = bubbleRef.current?.getBoundingClientRect();
    const parentBox = bracketRef.current?.offsetParent?.getBoundingClientRect();

    if (replyBox && messageBox && parentBox) {
      const top = replyBox.top + replyBox.height / 2 - parentBox.top;
      const bottom = messageBox.top + messageBox.height / 2 - parentBox.top;
      const height = bottom - top;

      const line = bracketRef.current;
      line.style.top = `${top}px`;
      line.style.height = `${height}px`;
    }
  }, [message.repliedToMessage]);

  const hanldeCancelReplyTo = () => {
    onCancelReplyTo()
  };

  return (
    <div className={`${styles.messageThreadContainer} ${!message.repliedToMessage ? styles.indentIfNoReply : ""}`}>
      {message.repliedToMessage && (
        <div className={styles.verticalBracket}>
          <div ref={bracketRef} className={styles.bracketLine}></div>
        </div>
      )}

      <div className={styles.messageContent}>
        {message.repliedToMessage && (
          <ReplyPreview ref={replyRef}
            isReplying={false}
            message={message.repliedToMessage}
            onCancel={onCancelReplyTo}
          />
        )}
        <div ref={bubbleRef}
          className={`${styles.messageBubble} ${styles[messageStyle + "Bubble"]} 
          ${message.currentContactId === message.fromContactId ? styles.myMessageBubble : ""}`}>
          <div className={styles.messageHeader}>
            <div className={styles.name}>{message.name}</div>
            <div className={styles.sentAt}>{formatMessageDate(message.date)}</div>
          </div>
          <div className={styles.bodyRow}>
            <div className={styles.message}>{message.message.trim()}</div>
            <FontAwesomeIcon icon={faReply} className={styles.replyIcon} onClick={() => onReplyClick(message)} />
          </div>
        </div>
      </div>
    </div>
  );
}

MessageItem.propTypes = {
  message: PropTypes.shape({
    name: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
  }).isRequired,
  onReplyClick: PropTypes.func.isRequired,
};
